/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { CheckboxComponent } from '../../../../Display/NDC/component/NDCDetails/CMSDrug/CMSDrugInputContainer';
import { NDCDetailsTextFieldComponent } from '../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { formatQuater } from '../../store/action';

const SelectedClaimDrugContainer = ({
  data,
  selectedClaimFilter,
  claimReferenceData,
}) => {
  const getDrugStatus = (value) => {
    if (
      claimReferenceData &&
      claimReferenceData.DRUG_STATUS_CD &&
      claimReferenceData.DRUG_STATUS_CD.length > 0
    ) {
      const index = claimReferenceData.DRUG_STATUS_CD.findIndex(
        (item) => item.codeValueID.codeValue === value
      );

      if (index !== -1) {
        return claimReferenceData.DRUG_STATUS_CD[index].shortDescription;
      }
      return '';
    }
    return '';
  };

  return (
    <div className="col-sm-12 mt-4">
      <fieldset className="custom-fieldset">
        <div className="p-0 mt-2 row">
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Selected Process Qtr"
              value={
                selectedClaimFilter &&
                selectedClaimFilter.processedQtr &&
                selectedClaimFilter.processedQtr.includes('Q') &&
                formatQuater(selectedClaimFilter.processedQtr)
              }
            />
          </div>
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Selected Provider ID Type"
              value={
                selectedClaimFilter && selectedClaimFilter.providerIdTypeCd
              }
            />
          </div>
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Selected Provider ID"
              value={selectedClaimFilter && selectedClaimFilter.providerId}
            />
          </div>
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Rebate Program"
              value={
                (selectedClaimFilter && selectedClaimFilter?.rebateProgramCd) ||
                'ALL'
              }
            />
          </div>
          {data && selectedClaimFilter?.rebateProgramCd !== 'ALL' && (
            <div className="col-4 d-flex">
              <CheckboxComponent
                label="Units modified through AR"
                checked={!!(data && data.unitsModFromArInd === 1)}
                labelPlacement="end"
                disabled={false}
                onChange={(e) => {}}
              />
            </div>
          )}
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Labeler Code"
              value={data && data.labelerCode}
            />
          </div>
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Name"
              value={data && data.labelerName}
            />
          </div>

          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Selected Claim Category Code"
              value={
                (selectedClaimFilter && selectedClaimFilter?.claimCategoryCd) ||
                'ALL'
              }
            />
          </div>
          {selectedClaimFilter?.rebateProgramCd !== 'ALL' && (
            <div className="col-4">
              <NDCDetailsTextFieldComponent
                className="ml-0"
                label="Drug Status"
                value={
                  data && data.drugStatus && getDrugStatus(data?.drugStatus)
                }
              />
            </div>
          )}
        </div>
      </fieldset>
    </div>
  );
};

export default SelectedClaimDrugContainer;
